/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientPermissionViewModel } from '../../models/client-permission-view-model';

export interface GetClientPermissions$Params {
  clientID: number;
}

export function GetClientPermissions(http: HttpClient, rootUrl: string, params: GetClientPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientPermissionViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientPermissions.PATH, 'get');
  if (params) {
    rb.path('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientPermissionViewModel>>;
    })
  );
}

GetClientPermissions.PATH = '/api/ClientUsers/{clientID}/GetClientPermissions';
